<style lang="stylus">
.stepsBorder {
  margin-bottom :32px;
  margin-top : 33px
}

.yellowLabel {
  background-color: #fec626;
  padding: 10px;
  margin-left: 20px;
}

.yellowCircle {
  color: rgb(51, 49, 48);
  background-color: #ffc527;
  border: 2px solid #ffc527;
  border-radius: 50%;
  padding: 4.5px 6px 4.5px 10.19px;
  margin-right: 10px;
  font-weight : bold;
}

.yellowCircle3 {
  border: 2px solid #DDDDDD;
  color: #DDDDDD;
  background-color: white;
  border-radius: 50%;
  padding: 4.5px 5.86px 4.5px 5.85px;
  margin-right: 10px;
  font-weight : bold;
}

.grey-text {
  color : #747474;
  font-weight : 400;
  font-size : 18px;
}

.login-steps-border {
  border-right: 1px solid #DDDDDD;
  padding-right:24px;
  margin-right:24px;
}
</style>

<template>
  <v-row justify="center" align-center>
    <div class="stepsBorder">
      <div class="d-none d-md-flex">
        <span class="yellowCircle" v-if="step == 1"> 1 </span>
        <v-icon
          color="#DDDDDD"
          width="35px"
          height="35px"
          style="font-size: 35px; margin-bottom: -7px; background: white; margin-right: 10px"
          v-if="step > 1"
          >mdi-check-circle-outline</v-icon
        >
        <span class="login-steps-border" style="font-weight: bold" v-if="step == 1"> Basic information </span>
        <span v-else class="grey-text login-steps-border">Basic information</span>
        <span
          class="yellowCircle"
          style="color: #dddddd; border-color: #dddddd; background-color: white"
          v-if="step < 2"
        >
          2
        </span>
        <span
          class="yellowCircle3"
          style="background-color: #ffc527; color: black; border: 2px solid #ffc527"
          v-if="step == 2"
        >
          2
        </span>
        <v-icon
          color="#fec627"
          width="35px"
          height="35px"
          style="margin-bottom: -7px; font-size: 35px; color: #dddddd; background: white; margin-right: 10px"
          v-if="step > 2"
          >mdi-check-circle-outline</v-icon
        >
        <strong v-if="step == 2" class="login-steps-border">
          <b>Contact Details</b>
        </strong>
        <span v-else-if="step == 3" class="login-steps-border grey-text"> Contact Details </span>
        <span v-else class="login-steps-border grey-text">Contact Details</span>
        <span class="yellowCircle3" v-if="step < 3"> 3 </span>
        <span class="yellowCircle" v-if="step == 3"> 3 </span>
        <!-- <v-icon color="#fec627" style="font-size:35px; padding-right:10px;" v-if="step == 3">fas fa-check-circle</v-icon> -->
        <strong v-if="step == 3">
          <b>Confirmation</b>
        </strong>
        <span v-else class="grey-text">Confirmation</span>
      </div>
    </div>
  </v-row>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    step: {
      type: Number
    }
  },

  methods: {}
});
</script>
